import { Component } from '@angular/core';
import { Dialog, ModalService, SharedModule } from '@vendure/admin-ui/core';

@Component({
    selector: 'vdr-export-format-dialog',
    template: `
    <ng-template vdrDialogTitle>Export Orders</ng-template>

    <div class="body">
      <p>Please select the export format:</p>
      <div style="margin: 16px 0;">
        <label for="format-select" style="display: block; margin-bottom: 8px; font-weight: 500;">
          Export Format:
        </label>
        <select
          id="format-select"
          [(ngModel)]="selectedFormat"
          class="form-control"
          style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;">
          <option value="order-fulfillment-export-format-dealomega">Order Fulfillment - Dealomega Format</option>
          <option value="order-export-format-dealomega-universal">Order - Dealomega Universal Format</option>
        </select>
      </div>
    </div>

    <ng-template vdrDialogButtons>
      <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="confirm()">OK</button>
    </ng-template>
  `,
    standalone: true,
    imports: [SharedModule],
})
export class ExportFormatDialogComponent implements Dialog<string> {

    resolveWith: (result?: string) => void;

    selectedFormat = 'order-fulfillment-export-format-dealomega';

    cancel() {
        // If user cancels, we typically pass no value
        this.resolveWith();
    }

    confirm() {
        // If user confirms, pass the selected format
        this.resolveWith(this.selectedFormat);
    }
}

export function createExportDialog(modalService: ModalService, title: string, onConfirm: (format: string) => void) {
    modalService.fromComponent(ExportFormatDialogComponent, {
        size: 'md',
    }).subscribe((result) => {
        if (result) {
            onConfirm(result);
        }
    });
}
